import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Blurb = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  width: 100%;
  height: 100%;
`;

export const WrapSkills = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;

  @media (max-width: 1024px) {
    justify-content: center;
  }

   /* regular phones and below */
   @media (max-width: 480px) {
    justify-content: center;
    padding: 20px 0;
  }
`;

export const Item = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;

  img {
    max-width: 600px;
    padding: 15px;
  }

  span {
    font-size: 20px;
    font-weight: 400;
    margin-left: 10px;
  }

  /* regular phones and below */
  @media (max-width: 480px) {
    flex-direction: column;

    span {
      text-align: center;
    }

    img {
      max-width: 300px;
      padding: 15px;
    }
  }
`;

export const SourcererLink = styled.div`
  display: flex;
  flex-direction: column;

  img {
    margin: 10px;
    border-radius: 10%;
    max-width: 20px;
    background-color: #000;
  }

  p {
    display: flex;
    align-items: center;

    a {
      color: #000
      font-weight: 700;
      text-decoration: none;

      &:hover {
        color: #00E7AA;
      
        text-decoration: none;}
    }
  }
`;

export const Desc = styled.div`
  p {
    display: flex;
    align-items: center;

    a {
      color: #000
      font-weight: 700;
      text-decoration: none;
      margin-bottom: 30px;
    }
  }
`;

export const CaptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    width: 200px;
    font-size: 30px;
    font-weight: 600;
    padding: 7px;
    border-bottom: 2px solid #656565;
    margin-bottom: 30px;
  }
`;